export const audCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'AUD',
});
